import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as common from '../../../../common'

export const DOC = gql`
  ${common.gql.dms.data.fragments.variable.DOC}
  fragment FragmentQuiverEvaluationIncomplete on QuiverEvaluationIncomplete {
    requires {
      ...FragmentVariable
    }
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentQuiverEvaluationIncompleteFragment,
  ents.core.quiver.Evaluation.Incomplete
>({
  requires: graphql.transformers.OUT.default(
    graphql.transformers.OUT.list(
      common.gql.dms.data.fragments.variable.TRANSFORMER,
      { onNullish: 'remove' },
    ),
    [],
  ),
})
